$ = require 'jquery'
EntityDisplay = require 'app/scripts/lib/entity-display'
IdCache = require 'app/scripts/db/id-cache'
ModelLoader = require 'app/scripts/db/model-loader'
Promise = require 'bluebird'
TFM = require 'app/scripts/lib/markdown/tfm'
TrelloMarkdown = require '@atlassian/trello-markdown'
Util = require 'app/scripts/lib/util'
_ = require 'underscore'
templates = require 'app/scripts/views/internal/templates'
{ truncate } = require 'app/common/lib/util/text/truncate'
l = require 'app/scripts/lib/localize'
parseURL = require 'url-parse'
xtend = require 'xtend'
ApiError = require 'app/scripts/network/api-error'
{ drawFavicon } = require 'app/scripts/lib/draw-favicon'
Backgrounds = require 'app/scripts/data/backgrounds'

execMatch = (match, url) ->
  if !url?
    return null

  parsed = parseURL(url)
  matchedValues = [url]

  for attr, expected of match
    if _.isString(expected)
      if expected != parsed[attr]
        return null
    else if _.isRegExp(expected)
      if (results = expected.exec(parsed[attr]))?
        matchedValues = matchedValues.concat(results[1..])
      else
        return null
    else
      throw Error('invalid specification')

  matchedValues

requestCache = {}
cachedLoad = ({ key, fallback, fromModelCache, fromApi }) =>
  modelFromCache = fromModelCache()
  if modelFromCache?
    return modelFromCache.get('name')

  requestCache[key] ?= fromApi()
    .tap => delete requestCache[key]
    .catch ApiError.NotFound, ApiError.Unauthorized, =>
      # Keep these negative hits in the requestCache to avoid
      # retrying the API
      setTimeout =>
        delete requestCache[key]
      , Util.getMs({ minutes: 5 })
      fallback

drawBoardIcon = (prefs) =>
  { backgroundImageScaled, backgroundImage, background } = prefs

  hexColor = Backgrounds[background]?.color

  smallUrl =
    Util.smallestPreviewBiggerThan(
      backgroundImageScaled
      64
      64
    )?.url ? backgroundImage

  Promise.try =>
    if smallUrl?
      new Promise (resolve, reject) =>
        img = document.createElement('img')
        img.setAttribute('crossorigin', 'anonymous')
        img.onload = -> resolve(img)
        img.onerror = -> reject()
        img.src = "#{smallUrl}?favicon"
  .then (img) =>
    drawFavicon(img, { url: smallUrl, color: hexColor })

boardIconCache = {}
boardIconCachedLoad = ({ key, fallback, fromModelCache, fromApi }) =>
  if boardIconCache[key]?
    return boardIconCache[key]

  modelFromCache = fromModelCache()
  prefs = modelFromCache?.get('prefs')

  if prefs?.background?
    return boardIconCache[key] = drawBoardIcon(prefs)
      .catch =>
        return fallback

  return boardIconCache[key] = fromApi()
    .tap => delete boardIconCache[key]
    .then (loadedPrefs) =>
      return drawBoardIcon(loadedPrefs)
    .catch ApiError.NotFound, ApiError.Unauthorized, =>
      # Keep these negative hits in the boardIconCache to avoid
      # retrying the API
      setTimeout =>
        delete boardIconCache[key]
      , Util.getMs({ minutes: 5 })
      return fallback
    .catch =>
      return fallback

module.exports = new class
  _knownUrls: [
    {
      key: 'trello board'
      match:
        protocol: location.protocol
        host: location.host
        pathname: ///
          ^
          /b/
          (
            [a-zA-Z0-9]{8}| # board shortlink
            [a-fA-F0-9]{24} # board longlink
          )
          (?: $ | /.*)
        ///
      previewClass: 'attachment-thumbnail-preview-trello-logo'
      getIcon: ([fullUrl, shortLink], modelCache) ->
        boardIconCachedLoad
          key: shortLink
          fallback: require('resources/images/services/trello.png')
          fromModelCache: ->
            modelCache.get('Board', IdCache.getBoardId(shortLink))
          fromApi: ->
            ModelLoader.loadBoardPrefs(shortLink)
      getText: ([fullUrl, shortLink], modelCache) ->
        cachedLoad
          key: shortLink
          fallback: fullUrl
          fromModelCache: -> modelCache.get('Board', IdCache.getBoardId(shortLink))
          fromApi: -> ModelLoader.loadBoardName(shortLink)
    }
    {
      key: 'trello action'
      match:
        protocol: location.protocol
        host: location.host
        pathname: ///
          ^
          /c/
          (
            [a-zA-Z0-9]{8}| # card shortlink
            [a-fA-F0-9]{24} # card longlink
          )
          (?: $ | /.*)
        ///
        hash: ///
          ^
          \#(?:comment|action)-([0-9a-f]{24})
          $
        ///
      previewClass: 'attachment-thumbnail-preview-trello-logo'
      getShared: ([fullUrl, shortLink, idAction], modelCache) ->
        Promise.try ->
          modelCache.get('Action', idAction) ?
          ModelLoader.loadAction idAction
          .catch ApiError, (->)
        .then (action) ->
          if action?
            {
              action: action
              memberCreator: modelCache.get('Member', action.get('idMemberCreator'))
            }
          else
            {}

      getIcon: ([fullUrl, shortLink, idAction], modelCache, shared) ->
        { memberCreator } = shared
        if (avatarUrl = memberCreator?.get('avatarUrl'))?
          [avatarUrl, '30.png'].join('/')
        else
          require('resources/images/services/trello.png')

      getText: ([fullUrl, shortLink, idAction], modelCache, shared) ->
        { action } = shared

        if !action?
          return fullUrl

        text = _.chain(new EntityDisplay('action')
          .getEntities(action.getDisplay(), action.get('data').card?.id))
        .map ({ type, text }) ->
          if type == 'member' && action.isCommentLike()
            text + ":"
          else if type == 'comment'
            TFM.comments.textInline(text)
          else
            text
        .join('')
        .value()

        truncate(text, 64)
    }
    {
      key: 'trello card'
      match:
        protocol: location.protocol
        host: location.host
        pathname: ///
          ^
          /c/
          (
            [a-zA-Z0-9]{8}| # card shortlink
            [a-fA-F0-9]{24} # card longlink
          )
          (?: $ | /.*)
        ///
      previewClass: 'attachment-thumbnail-preview-trello-logo'
      getIcon: ([fullUrl, shortLink], modelCache) ->
        boardIconCachedLoad
          key: shortLink
          fallback: require('resources/images/services/trello.png')
          fromModelCache: ->
            card = modelCache.get('Card', IdCache.getCardId(shortLink))
            if !card?
              return null
            modelCache.get('Board', card.get('idBoard'))
          fromApi: ->
            ModelLoader.loadCardIdBoard(shortLink)
              .then (idBoard) ->
                ModelLoader.loadBoardPrefs(idBoard)
      getText: ([fullUrl, shortLink], modelCache) ->
        cachedLoad
          key: shortLink
          fallback: fullUrl
          fromModelCache: -> modelCache.get('Card', IdCache.getCardId(shortLink))
          fromApi: -> ModelLoader.loadCardName(shortLink)
    }
    {
      key: 'fogbugz case'
      match:
        protocol: /^https?:$/
        host: /^([^\.]+)\.fogbugz\.com$/
        pathname: ///
         ^
          / f / cases /
          ([\d]+) # case number
        ///
      previewClass: 'attachment-thumbnail-preview-fogbugz-logo'
      icon: require('resources/images/services/fogbugz.png')
      getArgs: ([all, subdomain, caseNumber]) -> { caseNumber }
    }
    {
      key: 'kiln commit'
      match:
        protocol: /^https?:$/
        host: ///^ ([^\.]+)\.(?:fogbugz\.com/kiln|kilnhg\.com) $///
        pathname: ///
          ^
          / Code /
          ([^/]+) # Project
          /
          ([^/]+) # Repo
          /
          ([^/]+) # Branch
          / History /
          ([^/]+) # hash
        ///
      previewClass: 'attachment-thumbnail-preview-kiln-logo'
      icon: require('resources/images/services/kiln.png')
      getText: ([all, subdomain, project, repo, branch, hash]) ->
        if repo == 'Group'
          "#{ project } » #{ branch }: #{ hash }"
        else
          "#{ project } » #{ repo } » #{ branch }: #{ hash }"
      dataUrl: (url) ->
        url.replace( /// / Code / ///, '/trello/Code/')

      _processJSON: (url, json) ->
        if json.reviews?
          for review in json.reviews
            review.status = l(['known services', 'kiln commit', 'status', review.sStatus])
            review.url =
              url.replace(/// /Code/.*$ ///, "/Review/#{ review.sReview}")

        if json.sAuthor
          # Remove the email address from "John Doe <john@doe.org>"
          json.author = json.sAuthor.replace(/\s<.*$/, "")

        if json.hash
          json.shortHash = json.hash.substr(0, 6)

        if json.sDescription
          inlineFormatter = new TrelloMarkdown({
            restrict:
              block: [
                'paragraph'
                'newline'
              ]
              inline: [
                'break'
                'email'
                'emoji'
                'url'
              ]
          })
          json.shortCommitMessage = json.sDescription.split('\n')[0]
          json.commitMessageHtml =
            inlineFormatter.format(json.sDescription).output

        json.url = url
        json

      previewHtml: (url, json) ->
        templates.fill(
          'kiln_changeset_preview'
          @_processJSON(url, json)
        )

      previewHtmlError: (url, error) ->
        if /unable to access/i.test(error)
          url = ///^ https?://[-a-z0-9\.]+ (/kiln)? ///.exec(url)?[0]
          {
            login: l('known services.kiln commit.error')
          }
        else
          null

      thumbnailHtml: (url, json, data) ->
        templates.fill(
          'kiln_changeset_thumbnail'
          xtend(@_processJSON(url, json), data)
        )
    }
    {
      key: 'github commit'
      match:
        protocol: 'https:'
        host: 'github.com'
        pathname: ///
          ^
          /
          ([^/]+) / # user
          ([^/]+) / # repo
          commit /
          ([^/]{7,40}) # hash
          $
        ///
      previewClass: 'attachment-thumbnail-preview-github-logo'
      icon: require('resources/images/services/github.png')
      getText: ([all, user, repo, hash]) ->
        "#{ user }/#{ repo }: #{ hash.substr(0, 7) }"
    }
    {
      key: 'github issue'
      match:
        protocol: 'https:'
        host: 'github.com'
        pathname: ///
          ^
          /
          ([^/]+) / # user
          ([^/]+) / # repo
          issues /
          (\d+) # issue number
          $
        ///
      previewClass: 'attachment-thumbnail-preview-github-logo'
      icon: require('resources/images/services/github.png')
      getArgs: ([all, user, repo, number]) -> { user, repo, number }
    }
    {
      name: 'GitHub Pull Request'
      match:
        protocol: 'https:'
        host: 'github.com'
        pathname: ///
          ^
          /
          ([^/]+) / # user
          ([^/]+) / # repo
          pull /
          (\d+) # number
          $
        ///
      previewClass: 'attachment-thumbnail-preview-github-logo'
      icon: require('resources/images/services/github.png')
      getArgs: ([all, user, repo, number]) -> { user, repo, number }
      getText: ([all, user, repo, number]) ->
        "#{user}/#{repo}: Pull Request #{number}"
    }
  ]

  interpret: (url, modelCache) ->
    for entry in @_knownUrls
      if (parts = execMatch(entry.match, url))?
        return do (entry) ->
          { key, name, getText, getArgs, previewClass, icon, getShared, getIcon } = entry
          Promise.resolve(getShared?(parts, modelCache))
          .then (shared) ->
            text = if getText?
              getText(parts, modelCache, shared)
            else
              args = getArgs?(parts, modelCache) ? {}
              l(['known services', key, 'text'], args)

            if getIcon?
              icon = getIcon(parts, modelCache, shared)

            name ?= l(['known services', key, 'name'])

            return Promise.props({ name, previewClass, icon, text, type: entry.key })

    Promise.resolve()

  _runHandler: (name, url, args..., next) ->
    for known in @_knownUrls when execMatch(known.match, url)? && known[name]?
      { match, dataUrl } = known
      $.ajax {
        url: dataUrl(url)
        xhrFields: { withCredentials: true }
        headers: { 'X-Trello': "Is it me you're looking for?" }
        success: (json) ->
          next(null, known[name](url, json, args...))
        error: (xhr, error, errorText) ->
          errorHandler = "#{ name }Error"
          loadError = known[errorHandler]?(url, errorText, args...)
          next(loadError ? "could not load")
      }
      return
    next()
    return

  previewHtml: (url, next) ->
    @_runHandler('previewHtml', url, next)

  thumbnailHtml: (url, data, next) ->
    @_runHandler('thumbnailHtml', url, data, next)
